import { randomNumber } from './math';

export function desaturateColor(hexColor, percentage) {
  // Convert the hex color to RGB
  const rgb = hexToRgb(hexColor);

  // Calculate the luminosity of the color
  const luminosity = 0.299 * rgb.r + 0.587 * rgb.g + 0.114 * rgb.b;

  // Calculate the desaturated RGB values
  const desaturatedR = Math.round(rgb.r + (luminosity - rgb.r) * (percentage / 100));
  const desaturatedG = Math.round(rgb.g + (luminosity - rgb.g) * (percentage / 100));
  const desaturatedB = Math.round(rgb.b + (luminosity - rgb.b) * (percentage / 100));

  // Convert the desaturated RGB values back to hex
  return rgbToHex(desaturatedR, desaturatedG, desaturatedB);
}

// Helper function to convert hex color to RGB
function hexToRgb(hex) {
  const r = parseInt(hex.substring(1, 3), 16);
  const g = parseInt(hex.substring(3, 5), 16);
  const b = parseInt(hex.substring(5, 7), 16);
  return { r, g, b };
}

// Helper function to convert RGB values to hex color
function rgbToHex(r, g, b) {
  const componentToHex = (c) => {
    const hex = c.toString(16);
    return hex.length === 1 ? '0' + hex : hex;
  };
  return '#' + componentToHex(r) + componentToHex(g) + componentToHex(b);
}

export function gradient(value, colorStops) {
  // Ensure the value is within the range [0, 1]
  const clampedValue = Math.max(0, Math.min(1, value));

  // Handle the edge cases when clampedValue is exactly 0 or 1
  if (clampedValue === 0) {
    const [r, g, b] = colorStops[0];
    return rgbToHex(r, g, b);
  } else if (clampedValue === 1) {
    const [r, g, b] = colorStops[colorStops.length - 1];
    return rgbToHex(r, g, b);
  }

  // Calculate the index and interpolation factor based on the normalized value
  const index = Math.floor(clampedValue * (colorStops.length - 1));
  const factor = clampedValue * (colorStops.length - 1) - index;

  // Interpolate between the two adjacent colors
  const [r1, g1, b1] = colorStops[index];
  const [r2, g2, b2] = colorStops[index + 1];

  const r = Math.round(r1 + factor * (r2 - r1));
  const g = Math.round(g1 + factor * (g2 - g1));
  const b = Math.round(b1 + factor * (b2 - b1));

  return rgbToHex(r, g, b);
}

// Sequential color gradient from green to yellow
export function viridisGradient(value) {
  // Define the RGB values for the viridis color gradient
  const viridisColors = [
    [68, 1, 84],
    [71, 44, 122],
    [59, 81, 139],
    [44, 113, 142],
    [33, 144, 141],
    [39, 173, 129],
    [92, 200, 99],
    [170, 220, 50],
    [253, 231, 37],
  ];

  return gradient(value, viridisColors);
}

export const RDBU_STOPS = [
  [103, 0, 31],
  [178, 24, 43],
  [214, 96, 77],
  [244, 165, 130],
  [253, 219, 199],
  [247, 247, 247],
];

// Divergent color gradient from red to blue
export function rdBuGradient(value) {
  // Ensure the value is within the range [-1, 1]
  const clampedValue = Math.max(-1, Math.min(1, value));

  // Map the value from [-1, 1] to [0, 1]
  const normalizedValue = (clampedValue + 1) / 2;

  // Define the RGB values for the RdBu color gradient
  return gradient(normalizedValue, RDBU_STOPS);
}



export function shadeColor(color, percent) {
    var R = parseInt(color.substring(1, 3), 16);
    var G = parseInt(color.substring(3, 5), 16);
    var B = parseInt(color.substring(5, 7), 16);

    R = parseInt(R * (100 + percent) / 100);
    G = parseInt(G * (100 + percent) / 100);
    B = parseInt(B * (100 + percent) / 100);

    R = (R < 255) ? R : 255;
    G = (G < 255) ? G : 255;
    B = (B < 255) ? B : 255;

    var RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
    var GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
    var BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));

    return "#" + RR + GG + BB;
}

export function invertColor(hexTripletColor) {
    var color = hexTripletColor;
    color = color.substring(1); // remove #
    color = parseInt(color, 16); // convert to integer
    color = 0xFFFFFF ^ color; // invert three bytes
    color = color.toString(16); // convert to hex
    color = ("000000" + color).slice(-6); // pad with leading zeros
    color = "#" + color; // prepend #
    return color;
}


export function getColorFromStr(str) {
    const hash = hashStr(str)
    const colorId = hash % Colors.length
    return Colors[colorId] //new Color(materialDesignColors400[colorId])
}



export function resetColors() {
    nextColor = 0
}

const hashStr = (str) => {
    var hash = 0, i, chr;
    for (i = 0; i < str.length; i++) {
        chr = str.charCodeAt(i);
        hash = ((hash << 5) - hash) + chr;
        hash |= 0; // Convert to 32bit integer
    }
    return Math.abs(hash);
}
